import { jsx } from "react/jsx-runtime";
import { Group as Group$1 } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const Group = Group$1;
const BlockGroup = ({
  attrs,
  innerBlocks
}) => {
  const {
    alignItems = {
      default: "stretch"
    },
    backgroundImage,
    backgroundImageVisible = {
      default: true,
      lg_lte: true,
      sm_lte: true
    },
    backgroundPosition,
    backgroundSize,
    borderRadius,
    justifyContent = {
      default: "center"
    },
    loading = "lazy",
    margin = {
      marginBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    maxWidth = {
      default: "xl"
    },
    padding = {
      paddingTop: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingRight: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingLeft: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    ...groupProps
  } = attrs;
  return /* @__PURE__ */ jsx(Group, { alignItems, backgroundImage, backgroundImageVisible, backgroundPosition, backgroundSize, justifyContent, loading, maxWidth, borderRadius, ...groupProps, ...margin, padding, children: generateBlockList({
    blocks: innerBlocks
  }) });
};
export {
  BlockGroup as default
};
